import type { ConceptDef } from '../types';

export const greetingChoice: ConceptDef = {
  kind: 'tileMatch',
  id: 'greeting-choice',
  label: 'Greeting Choice',
  category: 'Social',
  description: 'Hear a social situation; tap the right greeting.',
  config: {
    promptMode: 'AUDIO',
    tileCount: 4,
    items: [
      { say: 'You meet a friend in the morning.', answer: '👋 Good morning' },
      { say: 'You see your teacher.', answer: '👋 Hello' },
      { say: 'A friend gave you a snack.', answer: '🙏 Thank you' },
      { say: 'You leave at the end of the day.', answer: '👋 Goodbye' },
      { say: 'You bumped into someone.', answer: '🙇 Sorry' },
    ],
  },
};
